import Vue from 'vue';
import store from '@/store';
import { calculateRanges } from '@/utils';
import debounce from 'lodash-es/debounce';
import settings from '@/settings';

export default class VideoController {
    constructor(videoId, context) {
        let video = store.getters['moduleApp/getVideoById'](videoId);
        this.video = video;
        this.context = context;
        let duration = video.duration;
        let ranges = calculateRanges(duration, settings.video.preferredRangeLength, settings.video.remainderThreshold);
        let parts = ranges.map((range, i) => {
            return {
                locked: true,
                progress: 0,
                completed: false,
                start: range[0],
                end: range[1]
            };
        });

        this.parts = parts;

        this.playhead = this.video.progress;

        let me = this;

        this.vm = new Vue({
            data: {
                video
            },
            watch: {
                'video.progress': function (val) {
                    me.updateParts();
                    if (val < me.playhead) {
                        me.seek(val);
                    }
                }
            }
        });

        this.updateParts(true);
    }

    updateParts(initial = false) {
        let progress = this.video.progress;
        if (initial) {
            window.dataLayer.push({
                event: 'video_open',
                video: this.video.id,
                title: this.video.title
            });
        }
        if (progress > 0) {
            if (!this.playEventRegistered) {
                window.dataLayer.push({
                    event: 'video_start',
                    video: this.video.id,
                    title: this.video.title
                });
                this.playEventRegistered = true;
            }
        }

        this.parts.forEach((part, i) => {
            if (part.end <= progress) {
                if (!initial) {
                    if (!part.completed) {
                        this.onPartCompleted(i);
                    }
                }
                part.completed = true;
                part.progress = 1;
                part.locked = false;
            } else {
                part.completed = false;
                part.progress = Math.max(0, (progress - part.start) / (part.end - part.start));
                part.locked = true;
            }
        });
        let firstUncompletedPart = this.parts.find(part => !part.completed);
        if (firstUncompletedPart) {
            firstUncompletedPart.locked = false;
        }
    }

    setPlayer(player) {
        this.player = player;
        this.player.$on('position', playhead => {
            this.playhead = playhead;
            updateProgress(this.video, playhead, this.context);
        });
    }

    seek(position) {
        // if (position > this.video.progress) {
        //   position = this.video.progress
        // }
        this.playhead = position;
        this.player.seek(this.playhead);
    }

    play() {
        this.player.start();
    }

    videoCompleted(partIndex) {
        return this.parts.length === partIndex + 1;
    }

    onPartCompleted(partIndex) {
        // if (!store.getters['moduleApp/autoplayVideoParts']) {
        //   this.player.stop()
        // }
        window.dataLayer.push({
            event: 'video_part_completed',
            video: this.video.id,
            title: this.video.title,
            part: partIndex
        });
        if (this.videoCompleted(partIndex)) {
            window.dataLayer.push({
                event: 'video_completed',
                video: this.video.id,
                title: this.video.title,
                part: partIndex
            });
        }
    }

    destroy() {
        // vm.$destroy();
    }
}

const updateProgress = debounce(
    (video, playhead, context) => {
        if (playhead > video.progress) {
            store.dispatch('moduleApp/updateProgressOnVideo', { id: video.id, value: playhead, lifeskillId: context });
        }
    },
    500,
    { maxWait: 1000 }
);
